import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import _InputMultiBase from '../_InputMultiBase/_InputMultiBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SelectBox.html?raw';
//import DataItems = require("DataItems");
import docu from './SelectBoxDocumentation.html?raw';
import { AccessibilityLabelsHelper, TranslationHelpers } from "../../../more/Helpers";
interface SelectBoxEntry {
    node: HTMLOptionElement;
    isSelectable: boolean;
    value: string;
    label: string;
    bgColor?: string;
    txtColor?: string;
    entity?: any;
}


class SelectBox extends compose(_LabelInputBase, _InputMultiBase) {
    templateString: any = template;

    protected inputNode: HTMLSelectElement;
    protected inputNodeContainer: HTMLElement;
    errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";

    private valueAttribute: string = "ID";
    private labelAttribute: string;
    private colorAttribute: string;
    private dataCyAttribute: string;

    protected _options: Array<HTMLOptionElement> = new Array<HTMLOptionElement>();
    private entities: Array<any> = null;
    selectedEntry: SelectBoxEntry = null;

    entries: Array<SelectBoxEntry> = new Array<SelectBoxEntry>();

    multiselectHeight: number = 5; 

    blankOption: SelectBoxEntry = null;

    private _selectedValues: Array<string> = [];
    private _selectedEntities: Array<object> = [];


    protected highlightOnBlankValue: boolean = false;

    focus() {
        this.inputNode.focus();
    }

    getInputNode(): HTMLSelectElement {
        return this.inputNode;
    }

    protected _onChange_InputNode(evt?: any): void {
        console.log("_onChange_InputNode", evt.target.value, this.inputNode.value, evt);

        if (this.isMultiSelect === true && this.minCount == 1 && this.maxCount == 1 && evt.type == "click") { // spezialmodus... isMultiSelect = true, aber nur ein eintrag ist erlaubt. jeder click setzt den einzigen eintrag als value
            this.setValue(evt.target.value);
        } else if (evt.type != "click"){
            this.setValue(this.inputNode.value); // normaler modus ignoriert das click-event und wird nur über onchange gesteuert
        }        
    }

    protected _getEntryFromValue(searchValue: string): SelectBoxEntry {
        //console.log("Selectbox _getEntryFromValue", searchValue, this.entries);
        for (var i = 0; i < this.entries.length; i++) {
            if (this.entries[i].value == searchValue) {
                return this.entries[i];
            }
        }

        return null;
    }
/**
* Wert des Controls setzen.
 * @param bSuppressChange Auslösen eines Änderungs-Emits unterdrücken (true)
 * @param delimiter Falls ein Trennzeichen angegeben wird, trennt sich newValue in ein Array und das Select wird in den Multiple-Modus gesetzt.
*/
    setValue(newValue: string | number, bSuppressChange?: boolean, forceIfDisabled?: boolean, delimiter?: string, bSupressValidation?: boolean): void {
        let oldValue = this._value;

        if (newValue === "null") newValue = null; // Spezialfall....
        if (oldValue == "null") oldValue = null; // weil null auf dem input zu "null" wird

        //console.log("selectbox newValue", newValue, delimiter);
        var values: Array<any> = [newValue];
        if (typeof (delimiter) != "undefined" && typeof(newValue) == "string") {           

            if (this.isMultiSelect != true) {

                this.setMultiselect(true);
            }
            values = newValue.split(delimiter);
        }

        this._value = newValue;
        let bHasChanged = newValue !== oldValue;


        if (this.isMultiSelect == true) {

            this.setMultipleValues(values, true, bSuppressChange === true, forceIfDisabled === true);
            return;
        }


        this.inputNode.value = this._value;

        //var entry: SelectBoxEntry = this._getEntryFromValue(newValue);
        //if (entry != null) {
        //    this.selectedEntry = entry;
        //} else {
        //    this.selectedEntry = null;
        //}

        
        this._updateSelectedEntriesFromValue(forceIfDisabled, bSupressValidation);

        if (bSuppressChange === true || !bHasChanged) { }
        else {
            this.__delayValueChangeEmit(10);
        }
    }

    setColorAttribute(bgColorAttribute: string, txtColorAttribute: string) {

        if (this.entities?.length && this.entries?.length) {
            // neu aufbauen...
            let value = this._value;
            this.clear(true);
            this.setData(value,
                this.entities,
                this.valueAttribute,
                this.labelAttribute,
                true,
                bgColorAttribute,
                txtColorAttribute);

            this.applyColorFromValue();
        }
    }

    private applyColorFromValue() {
        if (this.selectedEntry) {
            this.setColor(this.selectedEntry.bgColor, this.selectedEntry.txtColor);
        } else {
            this.setColor(null, null);
        }
    }

    setColor(hexBG: string, hexTXT: string) {
        if (hexBG) {
            this.UiModder.domStyle.set(this.inputNode, "backgroundColor", hexBG);
        } else {
            this.UiModder.domStyle.set(this.inputNode, "backgroundColor", "");
        }

        if (hexTXT) {
            this.UiModder.domStyle.set(this.inputNode, "color", hexTXT);
        } else {
            this.UiModder.domStyle.set(this.inputNode, "color", "");
        }
    }

    setMultipleValues(newValue: Array<string>, unselectOther?: boolean, bSuppressChange?: boolean, forceIfDisabled?: boolean): void {

        //console.log("setMultipleValue", newValue, this.multiple.currentSelect);

        // hier für jedes Entry ein unselect durchführen
        if (unselectOther === true) {
            let currentSelectCopy = new Array<SelectBoxEntry>();
            for (let i = 0; i < this.currentSelect.length; i++) {
                let tmpEntry = this.currentSelect[i];
                currentSelectCopy.push(tmpEntry);
            }

            for (var i = 0; i < currentSelectCopy.length; i++) {
                let tmpEntry: SelectBoxEntry = <SelectBoxEntry>currentSelectCopy[i];
                //console.debug("unselect other", currentSelectCopy, tmpEntry);
                this._unselectEntry(tmpEntry);
            }
        }

        for (let i = 0; i < newValue.length; i++) {
            let value = newValue[i];
            let entry: SelectBoxEntry = this._getEntryFromValue(value);

            if (entry == null) {
                entry = this.addEntry(value, "??" + value, false);
            }

            this._selectEntry(entry, forceIfDisabled === true);
        }

        this._updateSelectedEntriesFromValue(forceIfDisabled);

        if (bSuppressChange === true) { }
        else {
            this.__delayValueChangeEmit();
        }
    }

    setData(presetValue: any,
        entityList: Array<any>,
        valueAttribute: string,
        labelAttribute: string,
        bSuppressChange?: boolean,
        bgColorAttribute?: string,
        txtColorAttribute?: string): void {

        this.clear(this._value === undefined || bSuppressChange == true);

        if (!this.entities) this.entities = [];

        this.valueAttribute = valueAttribute;
        this.labelAttribute = labelAttribute;

        if (entityList && entityList.length) {
            for (let entity of entityList) {

                this.entities.push(entity);

                let value = this.PitHelper.getEntityAttributeValue(entity, valueAttribute);
                let label = this.PitHelper.getEntityAttributeValue(entity, labelAttribute);

                let bgColorValue = null;
                let txtColorValue = null;


                if (bgColorAttribute) {
                    bgColorValue = this.PitHelper.getEntityAttributeValue(entity, bgColorAttribute);

                    if (typeof (bgColorValue) == "object" && bgColorValue.pitBGR) {
                        // pit-Farbobjekt 
                        let entityColorObj: more.EntityAPIColor = bgColorValue;
                        bgColorValue = entityColorObj.BackColor.Hex;
                        txtColorValue = entityColorObj.TextColor.Hex;
                    }
                }

                if (txtColorAttribute && bgColorAttribute != txtColorAttribute) {
                    txtColorValue = this.PitHelper.getEntityAttributeValue(entity, txtColorAttribute);

                    if (typeof (txtColorValue) == "object" && txtColorValue.pitBGR) {
                        // pit-Farbobjekt 
                        let entityColorObj: more.EntityAPIColor = txtColorValue;
                        txtColorValue = entityColorObj.TextColor.Hex;
                    }
                }

                this.addOption(value, label, true, bgColorValue, txtColorValue, entity);
            }

            this.constructOptions();
        }

        if (typeof (presetValue) !== "undefined") { // null muss auch zulässig sein!
            this.setValue(presetValue, bSuppressChange);
        }
    }

    

    setMultiselect(bMultipleAllowed: boolean, height?: number): void {
        super.setMultiselect.apply(this, arguments as any);

        if (typeof (height) == "number") {
            this.multiselectHeight = height;
        }

        this._setMultiselect(bMultipleAllowed, this.multiselectHeight);
    }

    setMultiselectHeight(lines: number): void {
        this.multiselectHeight = lines;

        if (true) {//this.isMultiSelect == true) {
            this.inputNode.size = this.multiselectHeight;
            //this.inputNode.rows = ...
        }

        if (this.isMultiSelect != true) {
            // w3-input weg
            this.UiModder.domClass.remove(this.inputNode, "w3-input");
            // w3-block rein
            this.UiModder.domClass.add(this.inputNode, "w3-block");
        } else {
            this.UiModder.domClass.add(this.inputNode, "w3-input");
            this.UiModder.domClass.remove(this.inputNode, "w3-block");
        }
    }

    setSelectHeight(lines: number): void {
        this.setMultiselectHeight(lines);
    }


    _setMultiselectSizeAttr(value: number): void {
        this.setMultiselectHeight(value);
    }

    private _setLabelattributeAttr(attr: string) {
        this._setLabelAttributeAttr(attr);
    }

    private _setLabelAttributeAttr(attr: string) {
        this.labelAttribute = attr;
    }

    private _setDataCyAttr(attr: string) {
        this.dataCyAttribute = attr;
        console.log(this.dataCyAttribute);
    }


/**
* Aktiviert oder deaktiviert Mehrfachauswahlmodus
* @param bMultipleAllowed Modus aktivieren oder deaktiviertn
 * @param inputHeightElements Wenn Modus aktiviert: Höhe des Inputs, Angabe in Zeilenanzahl
 * @param maxSelectable Maximal erlaubte Auswahlanzahl
 * @param minSelect Minimal notwendige Auswahl
*/
    private _setMultiselect(bMultipleAllowed: boolean, inputHeightElements: number, maxSelectable?: number, minSelect?: number): void{
        

        if (bMultipleAllowed === true) {
            this.setMultiselectHeight(inputHeightElements);
            this.inputNode.multiple = true;
            //this.isMultiSelect = true;

            if (typeof (maxSelectable) == "number") {
                this.maxCount = maxSelectable;
            }
            if (typeof (minSelect) == "number") {
                this.minCount = minSelect;
            }
            this.currentSelect = new Array<SelectBoxEntry>();

            // STYLING!
            //this.UiModder.domStyle.set(this.inputNode, "height", "unset!important"); // wegen W3 ....
            this.UiModder.domClass.remove(this.inputNode, "w3-input");
            this.UiModder.domClass.add(this.inputNode, "w3-block w3-padding-small");

            //this.setValue(null, true);
            this._value = null;
            
        } else {
            this.UiModder.domAttr.remove(this.inputNode, "multiple");
            this.UiModder.domAttr.remove(this.inputNode, "size");
            //this.isMultiSelect = false;

            //this.UiModder.domStyle.set(this.inputNode, "height", ""); // wegen W3 ....
            this.UiModder.domClass.add(this.inputNode, "w3-input");
            this.UiModder.domClass.remove(this.inputNode, "w3-block w3-padding-small");
        }

        this.constructOptions();
    }


    protected customValidation(): boolean {

        let result = true;
        let value = this.getValue(false);
        if (this.isMandatory) {

            if (!value) {
                result = false;
            }

            if (value == this.blankOption?.value && this.blankOption != null) {
                if (!this.blankOption.isSelectable) {
                    result = false;
                }
            }

            if (!result) {
                //this.validationErrorMsgText = this.translations["Generic__invalid_selection"];
            }

        }

        return result;
    }

    protected _setValidationResultStyle(): void {
        super._setValidationResultStyle.apply(this, arguments as any);

        var bHighlight = false;

        //console.debug("Selectbox _setValidationResultStyle", "valid?", this.isValid, "override?", this._manualHighlightOverride);

        if (this._manualHighlightOverride != true) {

            // Mehrfachauswahl - passt Anzahl der gewählten Elemente?
            bHighlight = !this.isValid && this.validationEnabled == true;

            
        } else {
            bHighlight = this._manualHighlightOverride;
            
        } 

        //console.debug("highlight edit manual?", this._manualHighlightOverride, bHighlight);

        //if (bHighlight) {
        //    this.UiModder.domClass.add(this.labelNode, "w3-text-red");
        //    this.UiModder.domClass.add(this.inputNode, "w3-border-red w3-pale-red");
        //} else {
        //    this.UiModder.domClass.remove(this.labelNode, "w3-text-red");
        //    this.UiModder.domClass.remove(this.inputNode, "w3-border-red w3-pale-red");
        //}
    }

    //emitChangeEvent(): void {
    //    this.emit("valueChange", this._value);
    //    this.emit("change", this._value);
    //}

    getValue(bReturnLabels?: boolean): any {

        if (this.isMultiSelect == true) {
            var values: Array<string> = this.getMultipleValues(bReturnLabels);

            return values.toString();
        }
        //console.debug("selectbox getValue", this.selectedEntry, this._value);

        if (this.selectedEntry != null) {
            if (bReturnLabels === true) {
                return this.selectedEntry.label;
            }

            if (this.selectedEntry.value == '$$xyz##$$') {
                return null;
            }

            return this.selectedEntry.value;
        }
        
        return this._value;
    }

    getMultipleValues(bReturnLabels?: boolean): Array<string> {
        if (this.isMultiSelect == true) {
            var values: Array<string> = [];

            for (var i = 0; i < this.currentSelect.length; i++) {
                if (bReturnLabels === true) {
                    values.push(this.currentSelect[i].label);
                } else {
                    values.push(this.currentSelect[i].value);
                }
                
            }

            return values;
        }

        return [this.getValue(bReturnLabels)];
    }

/**
* Leer-Wert abrufen (für Vergleich ob bereits ein "valider" Wert ausgewählt wurde).
* Null, falls null hinterlegt ist.
* Undefined, falls es keinen Leer-Wert gibt.
*/
    getBlankValue(): string {
        if (this.blankOption == null) {
            return undefined;
        }

        return this.blankOption.value;
    }


/**
* aus dem aktuell gesetzten Wert die tatsächliche (HTML-)Option ermitteln; Styles und Labels setzen; das gewählte Entry hinterlegen
*/
    private _updateSelectedEntriesFromValue(forceIfDisabled?: boolean, bSupressValidation?: boolean): void {

        let value: string = this._value;
        let values: Array<string> = [];
        if (this.isMultiSelect == true) {
            values = this.getMultipleValues();
        }
        //console.log("Selectbox _adjustCurrentSelection", value, values, this.entries);
        this.selectedEntry = null;

        if (this.blankOption) {
            if (this._value == this.blankOption?.value) this._selectEntry(this.blankOption);
            else this._unselectEntry(this.blankOption);

            if (this._value == this.blankOption.value && this.blankOption.node) {
                this.blankOption.node.selected = true;
                this.inputNode.value = this._value;
            }
        }

        for (let i = 0; i < this.entries.length; i++) {
            let entry: SelectBoxEntry = this.entries[i];
            let option: HTMLOptionElement = entry.node;

            if (option != null) {
                let optionValue = option.value;

                if ((this.isMultiSelect == true && values.indexOf(optionValue) != -1) ||
                    (this.isMultiSelect != true && value == optionValue)) {
                    this._selectEntry(entry, forceIfDisabled);
                    if (this.isMultiSelect != true) {
                        this.selectedEntry = entry;                        
                    }
                } else {
                    this._unselectEntry(entry);
                }
            }
        }

        this.applyColorFromValue();

        //this._updateValue();

        if (bSupressValidation !== true) {
            this.validateInput();
        }
    }

/**
* neuen Eintrag zu den auswählbaren Optionen hinzufügen
 * ACHTUNG: wird noch nicht im Control erzeugt!
*/
    addEntry(value: string, label: string, isSelectable?: boolean, bgColor?: string, txtColor?: string, entity?: any): SelectBoxEntry {
        if (label && TranslationHelpers.canTranslate(label)) label = TranslationHelpers.translate(label);
        var entry: SelectBoxEntry = {
            node: null,
            value: value,
            label: label,
            isSelectable: isSelectable != false,
            bgColor: bgColor,
            txtColor: txtColor,
            entity: entity
        };
        //console.debug("Selectbox addentry", entry);
        this.entries.push(entry);

        return entry;
    }

/**
* neuen Eintrag zu den auswählbaren Optionen hinzufügen (Alias für addEntry)
 * ACHTUNG: wird noch nicht im Control erzeugt!
*/
    addOption(value: string, label: string, isSelectable?: boolean, bgColor?: string, txtColor?: string, entity?: any) {
        this.addEntry(value, label, isSelectable, bgColor, txtColor, entity);
    }

    /**
* Einen "bitte wählen"-Platzhalter mit eigener Beschriftung anzeigen.
Wenn der Wert selektierbar ist, wird null als Wert angenommen.
*/
    setBlankOption(label: string, isSelectable?: boolean)

    /**
* Einen "bitte wählen"-Platzhalter anzeigen oder entfernen (Standardbeschriftung).
*/
    setBlankOption(bDisplayBlankOption: boolean, isSelectable?: boolean)
    /**
* (leere) Standardauswahl erzeugen, üblicherweise als Platzhalter
 * Achtung: muss mit constructOptions bestätigt werden!
 * null als Value ist zulässig. Mit undefined wird die Blank-Option wieder entfernt.
*/
    setBlankOption(value: string, label: string, isSelectable?: boolean)    
    setBlankOption(param1: string | boolean, param2?: string | boolean, param3?: string | boolean) {

        let value: string = undefined;
        let label: string;
        let isSelectable: boolean = false;

        // gemeint ist "nein, keine blank option":
        if (param1 === false) {
            value = undefined;
            label = null;
        } else if (param1 === true) { // "ja, blank option aktivieren":
            value = null;
            label = TranslationHelpers.tryTranslate("General_Label__BlankChooseValue");
            isSelectable = false;
            if (param2 === true || param2 === false) {
                isSelectable = param2;
                if( isSelectable) label = TranslationHelpers.tryTranslate("General_DropdownBlank_NoSelection");
            } else if (typeof (param2) == "string" || param2 === null) {
                // als 2. Parameter ist ein eigener Wert für die Blankoption definiert worden
                value = param2;

                if (param3 === true) {
                    isSelectable = param3;
                }
            }
        } else if (typeof (param1) == "string") { 
            // wenn param1 und param2 string, dann value + label; wenn nur param1 string, dann label (value = null) und param2 evtl isSelectable
            // param2 ist kein String. dann wurde ein label übergeben. als value null annehmen
            if (typeof (param2) != "string") {
                value = null;
                label = TranslationHelpers.tryTranslate(param1);
                if (param2 === true || param2 === false) {
                    isSelectable = param2;
                }
            }
            // als param1 wurde eine value übergeben, param2 ist das label (legacy modus)
            else if (typeof (param2) == "string") {
                value = param1;
                label = TranslationHelpers.tryTranslate(param2);
                if (param3 === true) {
                    isSelectable = param3;
                }
            } else { // doch nix
                
            }
        }

        if (typeof (value) === "undefined") {
            this._constructBlankOption(false);
            this.blankOption = null;
        } else {
            this.blankOption = { value: value as any, label: label, isSelectable: isSelectable !== false, node: null };
            if (this.isMultiSelect != true) {
                this.setValue(param1 as any, true);
            }
        }

      

        //this._constructBlankOption();
    }

/**
* Options-Einträge aus den Entries erzeugen. Diese müssen vorher befüllt sein!
*/
    constructOptions(): void {
        this.UiModder.domConstruct.empty(this.inputNode);
        this._clearOptions();

        this._options = new Array<HTMLOptionElement>();
        //console.debug(this.id + " _constructOptions", this.entries);

        this._constructBlankOption();

        // aus den geladenen Daten die selects erstellen
        if (this.entries != null) {
            for (var i = 0; i < this.entries.length; i++) {
                var entry: SelectBoxEntry = this.entries[i];

                if (typeof (entry.node) == "undefined") {
                    entry.node = null;
                }

                if (entry.node != null) {
                    this.UiModder.domConstruct.destroy(entry.node);
                    entry.node = null;
                }
                //console.debug("construct option", entry);
                this._constructOption(entry);
                
            }
        }

        //this.set("value";
        this._updateSelectedEntriesFromValue();
    }

/**
* Intern: einzelne Option-Node erzeugen und HTML-Node zurückgeben
*/
    protected _constructOption(entry: SelectBoxEntry): HTMLOptionElement {
        var option: HTMLOptionElement = entry.node;
        if (typeof (option) == "undefined") {
            option = null;
        }
        //var optionIcon: HTMLElement = null;
        //var optionText: HTMLElement = null;

        if (option == null) {
            option = <HTMLOptionElement>this.UiModder.domConstruct.create("option", {}, this.inputNode);
            //optionIcon = <HTMLOptionElement>this.UiModder.domConstruct.create("i", {
            //    className: "fa fa-square-o", "aria-hidden": true
            //}, option);

            //optionText = <HTMLOptionElement>this.UiModder.domConstruct.create("span", {
            //    className: ""
            //}, option);
        }
        option.value = entry.value;
        //this.UiModder.domAttr.set(option.children[1], "innerHTML", entry.label);
        this.UiModder.domAttr.set(option, "innerHTML", entry.label);

        if (entry.bgColor) this.UiModder.domStyle.set(option, "backgroundColor", entry.bgColor);
        if (entry.txtColor) this.UiModder.domStyle.set(option, "color", entry.txtColor);

        this.setOptionStyle(option, entry.isSelectable === true);

        if (this.isMultiSelect == true) {
            option.onmousedown = lang.partial(function (opt: HTMLOptionElement, entry: SelectBoxEntry, root: SelectBox, e) {
                //console.debug("mousedown option", opt, domAttr.get(opt, "selected"));
                e.preventDefault();
                if (root.isReadonly == true) {
                    return;
                }
                if (opt.disabled == true) {
                    //opt.selected = false;
                    if (opt.selected == true) {
                        root._unselectEntry(entry);
                    } else {
                        return;
                    }
                }
                else if (opt.selected == true) {
                    //opt.selected = false;
                    //var index = root.multiple.currentSelect.indexOf(entry);
                    //if (index != -1) {
                    //    //root.multiple.currentSelect.splice(index);
                    //    root.multiple.currentSelect.splice(index, 1);
                    //}
                    root._unselectEntry(entry);
                } else {

                    if (true) { //root.multiple.currentSelect.length < root.multiple.maxCount || root.multiple.maxCount == null) {
                        //opt.selected = true;
                        root._selectEntry(entry);
                    }
                }
                root.validateInput();
                root.__delayValueChangeEmit();
            }, option, entry, this);
        }

        entry.node = option;

        this._options.push(option);
        return option;
    }


    clear(bSuppressChange: boolean = true): void {
        this.setValue(null, bSuppressChange);
        this._clearEntries();
        this._clearOptions();
    }

    private _clearOptions(): void {
        for (let option of this._options) {
            this.UiModder.domConstruct.destroy(option);
        }

        this.entities = [];

        this._options = [];
    }

    private _clearEntries(): void {
        this.entries = [];
    }

    protected _updateValue(): string {
        if (this.isMultiSelect == true) {
            var values: Array<string> = new Array<string>();
            for (var i = 0; i < this.currentSelect.length; i++) {
                values.push(this.currentSelect[i].value);
            }
            this._value = values.toString();
        } else {
            this._value = this.inputNode.value;
            if (this._value == "null") this._value = null;
        }

        return this._value;
    }

/**
* Intern: Markiert das entry als selektiert. Formatiert HTML-Knoten und setzt properties entsprechend.
*/
    protected _selectEntry(entry: SelectBoxEntry, forceIfDisabled?: boolean): void {

        //console.debug("selectbox _selectEntry", entry, forceIfDisabled);

        if (entry.isSelectable != true && forceIfDisabled !== true) {
            return;
        }

        if (this.isMultiSelect == true) {

            if (this.currentSelect.indexOf(entry) == -1) {
                this.currentSelect.push(entry);
            }
        }

        if (entry.node != null) {
            entry.node.selected = true;
            this.setOptionStyle(entry.node, entry.isSelectable);

            //this.UiModder.domClass.add(option, "selectboxitem-active");
        }

        this._updateValue();
    }

    // Überdefinition von InputMultiBase:
    addSelect(entry: SelectBoxEntry, forceIfDisabled?: boolean): void {
        this._selectEntry(entry, forceIfDisabled);
    }

    //protected addSelectLocal(select?: any): void {
    //    // set the attribute "checked" in the child calss
    //}

    removeSelect(entry: SelectBoxEntry): void {
        this._unselectEntry(entry);
    }

    removeCurrentSelectLocal(): void {
        // wird in der Kinderklasse ausprogrammiert - also hier

        // öh... ja passt schon oder?
    }

    protected _unselectEntry(entry: SelectBoxEntry): void {
        //console.debug("selectbox _unselectEntry", entry);
        if (this.isMultiSelect == true) {
            var index = this.currentSelect.indexOf(entry);
            if (index != -1) {
                //root.multiple.currentSelect.splice(index);
                this.currentSelect.splice(index, 1);
            }
        } else {

        }

        if (entry.node != null) {
            entry.node.selected = false;
            this.setOptionStyle(entry.node, entry.isSelectable);
            //this.UiModder.domClass.add(option, "selectboxitem-active");
        }

        this._updateValue();
    }

    private setOptionStyle(option: HTMLOptionElement, isSelectable?: boolean) {
        //console.debug("selectbox setOptionStyle", option, isSelectable);

        this.UiModder.domClass.add(option, "selectboxitem");
        option.disabled = isSelectable === false;

        

        if (isSelectable !== false) {
            this.UiModder.domClass.remove(option, "selectboxitem-notselectable");
        } else {
            this.UiModder.domClass.add(option, "selectboxitem-notselectable");
        }

        if (option.selected == true) {
            this.UiModder.domClass.add(option, "selectboxitem-active");
            
        } else {
            this.UiModder.domClass.remove(option, "selectboxitem-active");
        }
    }

    protected _constructBlankOption(bConstruct?: boolean): void {
        let option: HTMLOptionElement = null;
        //console.debug("selectbox _constructBlankOption", this.blankOption);
        if (this.blankOption != null && bConstruct !== false) {

            option = this._constructOption(this.blankOption);
            this.UiModder.domClass.add(option, "blankoption");

            if (this.blankOption.isSelectable !== true) {
                this.UiModder.domClass.add(option, "selectboxitem-disabled");
                option.disabled = true;
            }

            if (!this._value) {
                this._value = this.blankOption.value;
                this.inputNode.value = this._value;
            }

        } else if (bConstruct === false && this.blankOption != null) {
            //console.log("REMOVE BLANK OPTION");
            this._options.splice(this._options.indexOf(this.blankOption.node));
            this.UiModder.domConstruct.destroy(this.blankOption.node);
            this.blankOption.node = null;
        }

        if (option != null) {
            this.UiModder.domConstruct.place(option, this.inputNode, "first");
        }

        

        this._options.push(option);
    }

    protected _setReadonlyStyle(): void {
        this.UiModder.domAttr.set(this.inputNode, "disabled", this.isReadonly);
    }

    protected _setLabelPosition(position: "front" | "default") {
        switch (position) {
            case "front":
                this.UiModder.domConstruct.place(this.labelNode, this.inputNodeContainer, "first");
                break;

            default:
                this.UiModder.domConstruct.place(this.labelNode, this.domNode, "first");
                break;
        }
    }

    setPlaceholder(text: string): void {
        this.setBlankOption('$$xyz##$$', text, false);
    }

    getDocumentationContent(): string {
        return docu;
    }

    // dojo

    private _setBlankOptionAttr(value: string, label: string, bAvailable: boolean) {

        this.setBlankOption(value, label, bAvailable);
    }

    private _additionalRequestParameters;
    private __request;
    private _isInitialized: boolean = false;
    private _initialSuppressChange: boolean = false;
    private _initialValue: any;
    private callfunction: string;
    /**
   * Fügt dem Request ein Objekt "additionalParameters" ein, das aus den hier eingefügten Properties besteht.
   * @param param Name des Parameters
   * @param value Wert des Parameters
   */
    addAdditionalRequestParameter(param: string, value: any): void {
        if (!this._additionalRequestParameters) {
            this._additionalRequestParameters = {};
        }

        this._additionalRequestParameters[param] = value;
    }

    private _loadTimeout: any = null;
    loadListValues(presetValue?: any, bSuppressChangeEvent?: boolean): void {
        if (this._loadTimeout) {
            clearTimeout(this._loadTimeout);
        }

        // falls dojo-startup und ein anderes widget das Load zweimal aufrufen...
        this._loadTimeout = setTimeout(lang.hitch(this, this._startListValuesRequest, presetValue, bSuppressChangeEvent), 50);
    }

    private _startListValuesRequest(presetValue?: any, bSuppressChangeEvent?: boolean) {
        // nicht resetten, evtl wird ein Wert gesetzt und die möglichen Werte danach nachgeladen
        //
        //console.log("multiselect _loadListValues", presetValue);
        if (presetValue !== undefined) {
            this._selectedValues = [];// = null;
            this._selectedEntities = [];

            //this.set("value", presetValue);
        }
        else {

            if (this._selectedValues?.length > 0) {
                presetValue = this._selectedValues;
            } else {
                this._selectedValues = [];// = null;
                this._selectedEntities = [];
            }
        }

        //this._adjustCurrentSelectionState();

        

        if (this.__request != null) {
            //console.log("selectbox: request cancel");
            if (typeof this.__request.cancel == 'function') {
                this.__request.cancel();
            } else if (typeof this.__request.abort == 'function') {
                this.__request.abort();
            }

            this.__request = null;
        }

        this._loadTimeout = null;


        this.StandbyStart();

        let requestParams: object = {};

        requestParams["labelAttribute"] = this.labelAttribute;

        // Extraparameter
        if (this._additionalRequestParameters != null) {
            for (let key in this._additionalRequestParameters) {
                requestParams[key] = lang.clone(this._additionalRequestParameters[key]);
            }
        }
        if (this.callfunction) {
            this.StandbyStart();
            this.__request = this.RequestManager.callfunction(this.callfunction,
                requestParams,
                lang.hitch(this, this._onLoadListValuesResponse, presetValue, bSuppressChangeEvent),
                lang.hitch(this, this._onLoadListValuesError) as any
            );

        } else {
            this.StandbyStop();
            alert(this.id + ": no request callfunction for loading values defined!");
        }
    }

    private _onLoadListValuesError(error: more.requestErrorMessage) {
        alert(this.id + " loading failed: " + error.Message);
    }

    private _onLoadListValuesResponse(presetValue: any, bSuppressChangeEvent: boolean, response: any): void { // responsecallback

        this.__request = null;

        let responseList = [];
        // ist entweder klassisches pit-Datarray oder json-Array aus API
        if (this.dataFormat == "pit") {
            responseList = response.EntityDataArray;
        } else if (this.dataFormat == "json") {
            responseList = response;
            if (typeof (response) == "string") { // Kompatibilität mit bisher doppelt stringifizierten JSON-Responses
                responseList = JSON.parse(response);
            }
        }

        if (!this.labelAttribute || !this.valueAttribute) {
            alert("selectbox nicht bereit: labelattribute und/oder valueattribute nicht gesetzt! - " + this.id);

            this.StandbyStop();
        }

        // falls kein preset und noch in der Initialisierung, Vorgabewert aus _initialValue nehmen. könnte zwischenzeitlich gesetzt worden sein.
        if (presetValue === undefined && !this._isInitialized) {
            presetValue = this._initialValue;
            // falls es ein preset gibt und explizit (!!) ein suppressChange mitgegeben wurde, dann dieses übernehmen, falls nicht anders überschrieben.
            if (presetValue != undefined && typeof (this._initialSuppressChange) == "boolean" && typeof (bSuppressChangeEvent) == "undefined") {
                bSuppressChangeEvent = this._initialSuppressChange;
            }
        }

        this.setData(presetValue, responseList, this.valueAttribute, this.labelAttribute, bSuppressChangeEvent, this.colorAttribute, this.colorAttribute);


        this.emit("listValuesLoaded");
        this.emit("loaded");
        //if (presetValue != null && typeof (presetValue) != "undefined") {
        //    this.setValue(presetValue, bSuppressChangeEvent);
        //    this.confirmSelection(false);
        //}

        this.StandbyStop();


        //this._handleSearch();
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._options = [];
        this.entries = [];
        this.currentSelect = [];

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "selectInput", this.labelNode);
    }

    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.inputNode ?? this.domNode, "");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this.constructOptions();

        //this.setValue("it");
    }
}

export default mdsWidget(SelectBox);